export default defineAppConfig({
  ui: {
    // primary: 'blue',
    // primary: 'azure-radiance',
    // primary: 'sky',
    // CryptoSpace admin deploy smoke keeps this file in the admin publish path.
    primary: 'blue-ribbon',
    gray: 'neutral',
  }
})
